import BubbleChart from './BubbleChart';

export default BubbleChart;
